import { useEffect, useState } from "react";
import {
  FeatureFlag,
  getFeatureFlags,
} from "../apis/settings/feature.flags";

let cachedFlags: FeatureFlag[] | null = null;
let pendingRequest: Promise<FeatureFlag[]> | null = null;

export const resetFeatureFlagCache = () => {
  cachedFlags = null;
  pendingRequest = null;
};

const loadFlags = () => {
  if (cachedFlags) return Promise.resolve(cachedFlags);
  if (pendingRequest) return pendingRequest;
  pendingRequest = new Promise((resolve) => {
    getFeatureFlags({
      onCompleted: ({ data }) => {
        cachedFlags = data;
        pendingRequest = null;
        resolve(data);
      },
      onError: () => {
        pendingRequest = null;
        resolve([]);
      },
    }, { bypassCache: true });
  });
  return pendingRequest;
};

export const useFeatureFlag = (key: string) => {
  const [loading, setLoading] = useState(!cachedFlags);
  const [enabled, setEnabled] = useState(
    cachedFlags?.find((flag) => flag.key === key)?.enabled ?? false,
  );

  useEffect(() => {
    let active = true;
    loadFlags().then((flags) => {
      if (!active) return;
      setEnabled(flags.find((flag) => flag.key === key)?.enabled ?? false);
      setLoading(false);
    });
    return () => {
      active = false;
    };
  }, [key]);

  return { enabled, loading };
};
